import _ from 'lodash'
import { getToggles } from 'quick-quote/feature-toggles'
import { PATH } from '../../constants/path'
import getFNANavTabConfigs from './fna/tabs'
import getOldQQNavTabConfigs from './old-quick-quote/tabs'
import getQQv2NavTabConfigs from './quick-quote/v2/tabs'

export const isQuickQuotePath = (path) => {
  return _.includes(path, PATH.QUICK_QUOTE)
}

export const isFNAPath = (path) => {
  return _.includes(path, PATH.FNA)
}

const getTabsFromMatchingNav = (navConfigList, path) => {
  const navConfig = navConfigList.find((qqNav) => _.includes(path, qqNav.path))
  return navConfig ? navConfig.tabs : []
}

export const getNavTabList = ({ location, state }) => {
  const path = location.pathname
  if (isQuickQuotePath(path)) {
    return getTabsFromMatchingNav(getQQv2NavTabConfigs(state), path)
  } else if (isFNAPath(path)) {
    return getTabsFromMatchingNav(getFNANavTabConfigs(state), path)
  } else {
    return getTabsFromMatchingNav(getOldQQNavTabConfigs(state), path)
  }
}
